import React, { useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import "./modal.css";
import { Plus } from "react-feather";
import { ThemeContext } from "../../App";
 

function ModalDiv({ showModal, setShowModal, refresher }) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [background, setBackground] = useState("#F9F5EB");
  const [foreground, setForeground] = useState("#fff");
  const [priority, setPriority] = useState("normal");
  const theme = useContext(ThemeContext);

  const handleAdd = () => {
    const savedData = JSON.parse(localStorage.getItem("myNotes")) || [];
    if (!title || !content) {
      return alert("Title and Content is required");
    }
    let newData = {
      id: Date.now(),
      title,
      content,
      priority,
      background,
      foreground,
      date: new Date().toLocaleDateString(),
    };
    savedData.push(newData);
    localStorage.setItem("myNotes", JSON.stringify(savedData));
    setTitle("");
    setContent("");
    setPriority("normal");
    setShowModal(false);
    // window.location.reload()
    refresher();
  };

  const handleCancel = () => {
    setTitle("");
    setContent("");
    setPriority("normal");
    setShowModal(false);
  };

  const handleColor = (bg, fg) => {
    setBackground(bg);
    setForeground(fg);
  };

  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            className="form-control mb-3"
            placeholder="Enter title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <label>Priority</label>
          <select
            className="form-control mb-3"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
          >
            <option value="normal">Normal</option>
            <option value="high">High</option>
          </select>
          <textarea
            className="form-control"
            style={{ height: "180px" }}
            placeholder="Enter notes...."
            value={content}
            onChange={(e) => setContent(e.target.value)}
          ></textarea>
          {/* for theme selection */}
          <DropdownButton id="dropdown-basic-button" title="Select Theme">
            <Dropdown.Item href="#/action-1">
              <div
                className="d-flex"
                onClick={() => {
                  theme.theme === "light"
                    ? handleColor("#54BAB9", "#9ED2C6")
                    : handleColor("#472D2D", "#2C3333");
                }}
              >
                <div
                  className="circle"
                  style={
                    theme.theme === "light"
                      ? { backgroundColor: "#54BAB9" }
                      : { backgroundColor: "#041C32" }
                  }
                ></div>
                {"  "}
                <div
                  className="circle mx-3"
                  style={
                    theme.theme === "light"
                      ? { backgroundColor: "#9ED2C6" }
                      : { backgroundColor: "#420516" }
                  }
                ></div>
              </div>
              {"  "}
            </Dropdown.Item>
            <Dropdown.Item href="#/action-2">
              <div
                className="d-flex"
                onClick={() => {
                  theme.theme === "light"
                    ? handleColor("#FFE898", "#FFF8BC")
                    : handleColor("#060047", "#243763");
                }}
              >
                <div
                  className="circle"
                  style={
                    theme.theme === "light"
                      ? { backgroundColor: "#FFE898" }
                      : { backgroundColor: "#2D2424" }
                  }
                ></div>
                <div
                  className="circle mx-3"
                  style={
                    theme.theme === "light"
                      ? { backgroundColor: "#FFE898" }
                      : { backgroundColor: "#16213E" }
                  }
                ></div>
              </div>
            </Dropdown.Item>
            <Dropdown.Item href="#/action-3">
              <div
                className="d-flex"
                onClick={() => {
                  theme.theme === "light"
                    ? handleColor("#AfB4FF", "#B1E1FF")
                    : handleColor("#19282F", "#161853");
                }}
              >
                <div
                  className="circle"
                  style={
                    theme.theme === "light"
                      ? { backgroundColor: "#AfB4FF" }
                      : { backgroundColor: "#114E60" }
                  }
                ></div>
                {"  "}
                <div
                  className="circle mx-3"
                  style={
                    theme.theme === "light"
                      ? { backgroundColor: "#B1E1FF" }
                      : { backgroundColor: "#025955" }
                  }
                ></div>
              </div>
            </Dropdown.Item>
            <Dropdown.Item href="#/action-4">
              <div
                className="d-flex"
                onClick={() => {
                  theme.theme === "light"
                    ? handleColor("#F9F5EB", "#fff")
                    : handleColor("#54123B", "#23374D");
                }}
              >
                <div
                  className="circle"
                  style={
                    theme.theme === "light"
                      ? { backgroundColor: "#F9F5EB" }
                      : { backgroundColor: "#04322E" }
                  }
                ></div>
                {"  "}
                <div
                  className="circle mx-3 shadow"
                  style={
                    theme.theme === "light"
                      ? { backgroundColor: "#fff" }
                      : { backgroundColor: "#000000" }
                  }
                ></div>
                {"  "}
                Default
              </div>
            </Dropdown.Item>
          </DropdownButton>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAdd}>
            <Plus /> Add
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default ModalDiv;
